// Copyright (c) 2022 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap, tap } from "rxjs/operators"
import * as Actions from "../actions"
import { EMPTY_TRASH_DO_NOT_ASK_AGAIN_KEY, } from "./index"
import * as TrashedTimeSlice from "../trash/slice"

export type StorageWriter = (value: boolean) => void

export const persist: StorageWriter = (value) => {
  localStorage.setItem(EMPTY_TRASH_DO_NOT_ASK_AGAIN_KEY, value.toString())
}

export const persistEmptyTrashDoNotAskAgain = (persist: StorageWriter) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(TrashedTimeSlice.setEmptyTrashDoNotAskAgain.match),
      mergeMap(action => of(action.payload).pipe(
        tap(persist),
        map(_ => Actions.emptyTrashDoNotAskAgainPersisted()),
        catchError(_ => of(Actions.emptyTrashDoNotAskAgainPersistFailed())),
      )),
    )

export default persistEmptyTrashDoNotAskAgain(persist)
